module.exports = __webpack_public_path__ + "img/mycombo_added_service_bg_img.11554b67.png";